<template>
  <div>
    <el-dialog title="邀请成员" :visible.sync="visible" width="490px" class="invite-member-dialog member-dialog" :close-on-click-modal="false" :before-close="close">
      <div v-if="!inviteLink">
        <el-form ref="inviteForm" class="userForm" :model="inviteData" :rules="inviteCheck" label-width="100px" label-position="left">
          <el-form-item label="受邀手机号：" prop="phone" class="formLabel">
            <el-input v-model="inviteData.phone" placeholder="请确认填写的手机号和邀请的同事手机号保持一致"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="invite-link-content" v-if="inviteLink">
        <span>链接：</span>
        <el-input v-model="inviteLink" placeholder="请确认填写的手机号和邀请的同事手机号保持一致" :disabled="true"></el-input>
      </div>
      <span slot="footer" class="dialog-footer" v-if="!inviteLink">
        <el-button class="cancel-btn" @click="close">取消</el-button>
        <el-button type="primary" class="create-btn" @click="createInviteLink">生成邀请链接</el-button>
      </span>
      <span slot="footer" class="dialog-footer" v-if="inviteLink">
        <el-button type="primary" class="submit-btn" v-clipboard:copy="inviteLink" v-clipboard:success="onCopy" v-clipboard:error="onError">复制</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { httpAjax } from "@/api/ajax";
const rulePhone = /^\d{11}$/;///^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;// 手机号码校验规则
export default {
  name: "inviteMember",
  props: {
    visible: Boolean
  },
  data() {
    // 手机号验证
    const phoneValidate = async(rule, value, callback) => {
      if (value.length < 1) {
        return callback(new Error('手机号码不能为空'));
      } else if (!rulePhone.test(value)) {
        return callback(new Error('手机号码格式不正确'));
      } else{
        callback();
      }
    };
    return {
      inviteData: {
        phone: '',
      },
      inviteCheck: {
        phone: [{ required: true, validator: phoneValidate, trigger: ['blur', 'change'] }],
      },
      inviteLink:''
    };
  },
  created() {
		
	},
  methods: {
    createInviteLink(){
      this.$refs['inviteForm'].validate((valid) => {
        if (valid) {
          httpAjax({
            url: `/services/company/invite/url/${this.inviteData.phone}`,
            method: "get",
          }).then((response) => {
            if (response.success) {
              this.$message({
                message: '邀请链接生成成功',
                type: 'success'
              })
              this.inviteLink = response.data;
            } else {
              this.$message({
                message: response.msg,
                type: 'error'
              })
            }
          });
        }
      });
    },
    onCopy(e) {
      this.$message({
        message: '邀请链接复制成功',
        type: 'success'
      })
      this.close();
    },
    onError(e) {
      this.$message({
        message: '复制链接失败',
        type: 'error'
      })
    },
    // 关闭弹窗
    close(){
      this.$emit('close')
    },
	},
};
</script>

<style lang="less" scoped>
.invite-member-dialog {
  .el-input {
    width: 342px;
    height: 32px;
  }
  /deep/.el-input__inner {
    padding: 0 16px;
    height: 32px;
    line-height: 32px;
    border-radius: 4px;
  }
  /deep/.el-dialog__body {
    height: 174px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  .invite-link-content {
    .el-input {
      width: 400px;
    }
    .el-button--primary {
      width: 80px;
      height: 32px;
      border-radius: 4px;
      text-align: center;
      line-height: 32px;
      border: 0;
      padding: 0;
      margin-left: 16px;
    }
  }
  /deep/.el-form-item {
    margin-bottom: 0;
  }
  /deep/.el-form-item__label {
    padding: 0;
    line-height: 32px !important;
  }
  .create-btn {
    width: 116px !important;
  }
}
</style>
